// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XQc2","footer":"styles_footer__2BfhE"};